/* @jsx mdx */
import React from 'react'
import { mdx } from '@mdx-js/react'

import { FlexBox, Heading, Image, CodePane, Link, Appear } from "spectacle";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
import RICardoHome from "./RICardo_home.png";
import GPHHome from "./GPH_home.png";
import RICardoWorld from "./RICardo_world.png";
import RICardoDenmarkAnte from "./RICardo_denmark_ante.png";
import RICardoGermanyPartner from "./RICardo_germany_partner.png";
import GPHGermany from "./GPH_germany.png";
import RICardo_github from "./ricardo_data_github.png";
import dataPackage from "./datapackage.json";
import importApp1 from "./04_list_errors_by_group.png";
import importApp2 from "./08_fixing_a_foreign_key_on_partner.png";
import importApp3 from "./11_error_solving_summary.png";
import importApp4 from "./12_publish_to_github_or_download.png";
import RICardoMetadata from "./RICardo_metadata.png";
import GPHSankey from "./GPH_sankey.png";
import trade1860 from "./retina_1860.png";
import GPHLogo from "./GPH_logo.png";
import RICardoLogo from "./RICardo_logo.png";

function MDXContentWrapperSlide0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`RICardo and GeoPolHist`}</h1>
    <h3>{`Exploring trade relations`}<br />{`between the geopolitical entities of the world `}<br />{`from c. 1800 to 1938`}</h3>
    <FlexBox flexDirection="row" justifyContent="space-around" mdxType="FlexBox">
  <Heading fontSize={"h4"} mdxType="Heading">
    Béatrice Dedinger
    <br />
    Centre d’histoire de Sciences Po (CHSP)
  </Heading>
  <Heading fontSize={"h4"} mdxType="Heading">
    Paul Girard
    <br />
    OuestWare
  </Heading>
    </FlexBox>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide0.isMDXComponent = true;

function MDXContentWrapperSlide1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <ul>
      <li parentName="ul">{`2017 RICardo web application & data-set publication`}</li>
    </ul>
    <span className="citation" style={{
      fontSize: "1.5rem"
    }}>
  <b>Dedinger, B. and Girard, P.</b> (2017). Exploring trade globalization in
  the long run: The RICardo project.{" "}
  <i>
    Historical Methods: A Journal of Quantitative and Interdisciplinary History
  </i>
  , <b>50</b>(1): 30–48 doi:
  <a href="https://doi.org/10.1080/01615440.2016.1220269">
    10.1080/01615440.2016.1220269
  </a>
  .
  <br />
  <b>
    Girard, P., Dedinger, B., Ricci, D., Ooghe-Tabanou, B., Jacomy, M., Plique,
    G. and Tible, G.
  </b> (2016). RICardo Project : Exploring XIX Century International Trade. <i>
    Digital Humanities 2016: Conference Abstracts
  </i>. agiellonian University &amp; Pedagogical University, Kraków, Poland, pp.
  208–10 <a href="http://dh2016.adho.org/abstracts/177">
    http://dh2016.adho.org/abstracts/177
  </a>.
    </span>
    <ul>
      <li parentName="ul">{`2021 GeoPolHist web application & data-set publication`}</li>
    </ul>
    <span className="citation" style={{
      fontSize: "1.5rem"
    }}>
  <b>Dedinger, B. and Girard, P.</b> (2021). How many countries in the world?
  The geopolitical entities of the world and their political status from 1816 to
  the present.{" "}
  <i>
    Historical Methods: A Journal of Quantitative and Interdisciplinary History
  </i>
  , <b>0</b>(0). Routledge: 1–20 doi:
  <a href="https://doi.org/10.1080/01615440.2021.1939826">
    10.1080/01615440.2021.1939826
  </a>
  .
    </span>
    <ul>
      <li parentName="ul">{`2022 new RICardo data version`}<br />{`
added 230,000 new trade flows from primary sources`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide1.isMDXComponent = true;

function MDXContentWrapperSlide2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="https://ricardo.medialab.sciences-po.fr/" style={{
      height: "100%",
      width: "min-content"
    }}>
  <Image src={RICardoHome} height="100%" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide2.isMDXComponent = true;

function MDXContentWrapperSlide3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="https://medialab.github.io/GeoPolHist/#/" style={{
      height: "100%",
      width: "min-content"
    }}>
  <Image src={GPHHome} height="100%" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide3.isMDXComponent = true;

function MDXContentWrapperSlide4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>{`Three methodological innovations`}</h3>
    <ol>
      <li parentName="ol">{`Visual data exploration`}</li>
      <li parentName="ol">{`Frictionless data integration`}</li>
      <li parentName="ol">{`Analyzing heterogeneous data in the long-run`}</li>
    </ol>
    <Appear mdxType="Appear">
      <h3>{`Results of a long-lasting collaboration between an historian and a data engineer`}</h3>
      <div class="citation">
  <b>Girard, P.</b> (2018). Collaborative Humanities Paper presented at the
  DHnord, Lille{" "}
  <a href="https://vimeo.com/295788855#t=327s">
    https://vimeo.com/295788855#t=327s
  </a>{" "}
  (accessed 24 February 2022).
      </div>
    </Appear>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide4.isMDXComponent = true;

function MDXContentWrapperSlide5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Visual data exploration`}</h2>
    <p>{`Set of interactive data visualisations:`}</p>
    <ul>
      <li parentName="ul">{`to multiply points of view`}</li>
      <li parentName="ul">{`to offer visual documentation`}</li>
      <li parentName="ul">{`to unfold complexity`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://www.ouestware.com/2020/10/19/new-visualizations-RICardo/"
      }}>{`Post about data vizualisations design in RICardo 2020-10-19`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide5.isMDXComponent = true;

function MDXContentWrapperSlide6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="https://ricardo.medialab.sciences-po.fr/#!/world" style={{
      height: "100%",
      width: "min-content"
    }}>
  <Image src={RICardoWorld} height="100%" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide6.isMDXComponent = true;

function MDXContentWrapperSlide7(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="http://ricardo.medialab.sciences-po.fr/#!/reporting/Denmark" style={{
      height: "100%",
      width: "min-content"
    }}>
  <Image src={RICardoDenmarkAnte} height="100%" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide7.isMDXComponent = true;

function MDXContentWrapperSlide8(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="http://ricardo.medialab.sciences-po.fr/#!/partner/GermanyZollverein?selectedMinDate=1806&selectedMaxDate=1871" style={{
      height: "100%",
      width: "min-content"
    }}>
  <Image src={RICardoGermanyPartner} height="100%" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide8.isMDXComponent = true;

function MDXContentWrapperSlide9(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="https://medialab.github.io/GeoPolHist/#/country/255" style={{
      height: "100%",
      width: "min-content"
    }}>
  <Image src={GPHGermany} height="100%" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide9.isMDXComponent = true;

function MDXContentWrapperSlide10(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>
  <i>
    Frictionless<sup>*</sup>
  </i>{" "}
  Data Integration
    </h3>
    <ul>
      <li parentName="ul">{`Data documentation as a control tool for data-sets`}</li>
      <li parentName="ul">{`Keep track of versions to control update flows`}</li>
      <li parentName="ul">{`Enpower scholars with rich data curation tools`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://frictionlessdata.io/"
      }}>{`*`}{` See Datapackage from Frictionless data`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide10.isMDXComponent = true;

function MDXContentWrapperSlide11(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="https://github.com/medialab/ricardo_data/commit/16b628a6ff6c87c3f0c9ee1fcf7c8ebb51c58e13">
  <Image src={RICardo_github} height="80%" alt="" title="Denmark 1850 data glitch correction" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide11.isMDXComponent = true;

function MDXContentWrapperSlide12(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Datapackage: data documentation`}</h4>
    <CodePane language="json" height="80%" overflow="scroll" showLineNumbers={false} theme={tomorrow} mdxType="CodePane">
  {JSON.stringify(dataPackage, null, 2)}
    </CodePane>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide12.isMDXComponent = true;

function MDXContentWrapperSlide13(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Datapackage: data validation`}</h4>
    <CodePane language="yml" height="80%" overflow="scroll" showLineNumbers={false} theme={tomorrow} mdxType="CodePane">
  {`
    - resource:
      name: currencies
      title: currencies
      description: Currencies translation table
      format: csv
      encoding: utf-8
      path: data/currencies.csv
      profile: tabular-data-resource
      stats:
        hash: 51ae7953055c53284991bed94ebbfba0
        bytes: 1503652
        fields: 4
        rows: 36179
    time: 1.448
    errors:
      - cells:
          - piastre
          - '1830'
          - montevideo
          - ''
        rowNumber: 35447
        rowPosition: 35448
        code: foreign-key-error
        name: ForeignKey Error
        tags:
          - '#table'
          - '#row'
        note: 'for "modified_currency, year": values "None, 1830" not found in the
          lookup table "exchange_rates" as "modified_currency, year"'
        message: 'Row at position "35448" violates the foreign key: for "modified_currency,
          year": values "None, 1830" not found in the lookup table "exchange_rates"
          as "modified_currency, year"'
        description: Values in the foreign key fields should exist in the reference
          table
      - cells:
          - piastre
          - '1831'
          - montevideo
          - ''
        rowNumber: 35448
        rowPosition: 35449
        code: foreign-key-error
        name: ForeignKey Error
        tags:
          - '#table'
          - '#row'
        note: 'for "modified_currency, year": values "None, 1831" not found in the
          lookup table "exchange_rates" as "modified_currency, year"'
        message: 'Row at position "35449" violates the foreign key: for "modified_currency,
          year": values "None, 1831" not found in the lookup table "exchange_rates"
          as "modified_currency, year"'
        description: Values in the foreign key fields should exist in the reference
          table
    stats:
      errors: 2`}
    </CodePane>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide13.isMDXComponent = true;

function MDXContentWrapperSlide14(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>{`Dedicated integration application`}</h4>
    <p>{`Development of a specific web application to integrate new data:`}</p>
    <ul>
      <li parentName="ul">{`upload data spreadsheet`}</li>
      <li parentName="ul">{`check spreadsheet format`}</li>
      <li parentName="ul">{`detect and group unknown data points`}</li>
      <li parentName="ul">{`guide the data curation work`}</li>
      <li parentName="ul">{`commit into github`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide14.isMDXComponent = true;

function MDXContentWrapperSlide15(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={importApp1} position="absolute" top={0} right={0} width="100%" style={{
      zIndex: -1
    }} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide15.isMDXComponent = true;

function MDXContentWrapperSlide16(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={importApp2} position="absolute" top={0} right={0} width="100%" style={{
      zIndex: -1
    }} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide16.isMDXComponent = true;

function MDXContentWrapperSlide17(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={importApp3} position="absolute" top={0} right={0} width="100%" style={{
      zIndex: -1
    }} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide17.isMDXComponent = true;

function MDXContentWrapperSlide18(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={importApp4} position="absolute" top={0} right={0} width="100%" style={{
      zIndex: -1
    }} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide18.isMDXComponent = true;

function MDXContentWrapperSlide19(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>{`Analyzing heterogeneous data in the long-run`}</h3>
    <p>{`RICardo data set (c. 1800-1938)`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`630,000`}</strong>{` trade values`}</li>
      <li parentName="ul"><strong parentName="li">{`2,200`}</strong>{` trading entities`}</li>
      <li parentName="ul"><strong parentName="li">{`156`}</strong>{` currencies`}</li>
      <li parentName="ul"><strong parentName="li">{`7700`}</strong>{` annual exchange rates`}</li>
      <li parentName="ul"><strong parentName="li">{`4300`}</strong>{` archive volumes from `}<strong parentName="li">{`205`}</strong>{` sources`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide19.isMDXComponent = true;

function MDXContentWrapperSlide20(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="https://ricardo.medialab.sciences-po.fr/#!/metadata/bilateral" style={{
      width: "100%",
      overflow: "scroll"
    }}>
  <Image src={RICardoMetadata} width="100%" mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide20.isMDXComponent = true;

function MDXContentWrapperSlide21(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`GeoPolHist data set (1816-2022)`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`1,250`}</strong>{` geopolitical entities`}</li>
      <li parentName="ul"><strong parentName="li">{`20`}</strong>{` political status`}</li>
      <li parentName="ul">{`Geopolitical status over time`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide21.isMDXComponent = true;

function MDXContentWrapperSlide22(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <a href="https://medialab.github.io/GeoPolHist/#/">
      <Image src={GPHSankey} width="100%" style={{
        paddingTop: "20px"
      }} mdxType="Image" />
    </a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide22.isMDXComponent = true;

function MDXContentWrapperSlide23(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Link fontSize="3rem" style={{
      marginTop: "1rem",
      backgroundColor: "white"
    }} href="https://ouestware.gitlab.io/retina/beta/#/graph/?url=https%3A%2F%2Fmedialab.github.io%2Fricardo%2FWEHC_202207%2F1860.gexf&c=t&s=wot&sa[]=pg&sa[]=wot&ca[]=t&ca[]=g&ca[]=cn&ca[]=wot&fa=pr&nr=0.979" mdxType="Link">
  Trade in 1860
    </Link>
    <Image src={trade1860} position="absolute" top={0} right={0} width="95%" style={{
      zIndex: -1
    }} mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide23.isMDXComponent = true;

function MDXContentWrapperSlide24(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <div style={{
      fontSize: "1.3rem",
      marginTop: "2rem"
    }}>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "center"
            }}><strong parentName="th">{`reporting`}</strong></th>
            <th parentName="tr" {...{
              "align": "center"
            }}><strong parentName="th">{`year`}</strong></th>
            <th parentName="tr" {...{
              "align": "center"
            }}><strong parentName="th">{`expimp`}</strong></th>
            <th parentName="tr" {...{
              "align": "center"
            }}><strong parentName="th">{`partner`}</strong></th>
            <th parentName="tr" {...{
              "align": "center"
            }}><strong parentName="th">{`flow`}</strong></th>
            <th parentName="tr" {...{
              "align": "center"
            }}><strong parentName="th">{`nb_city_part_ofs`}</strong></th>
            <th parentName="tr" {...{
              "align": "center"
            }}><strong parentName="th">{`city_part_ofs`}</strong></th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1833`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`53332.027424094`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Balearic Islands`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1833`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`26487.7571008815`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Balearic Islands`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1834`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`260348.506401138`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`6`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cadix,Cartagena (Spain),A Coruna,Málaga,Bilbao,Santander`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1834`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`315821.084242137`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`6`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cadix,Cartagena (Spain),A Coruna,Málaga,Bilbao,Santander`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1835`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`465608.403162988`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`6`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cartagena (Spain),Bilbao,Santander,A Coruna,Cadix,Málaga`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1835`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`447633.659860734`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`6`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cartagena (Spain),Bilbao,Santander,A Coruna,Cadix,Málaga`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1836`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`403786.595216518`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`2`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Málaga,A Coruna`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1836`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`181015.800464951`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`2`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Málaga,A Coruna`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1837`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`247747.570523665`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Málaga`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1837`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`46032.1831844828`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Málaga`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1838`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`323799.032143841`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`2`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Santander,Málaga`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1838`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`134949.049848527`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`3`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Santander,Gijón,Málaga`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1839`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`504135.846655532`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`8`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cadix,A Coruna,Málaga,Bilbao,Santander,San Sebastián,Balearic Islands,Cartagena (Spain)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1839`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`561202.576950608`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`9`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cadix,A Coruna,Málaga,Bilbao,Santander,Gijón,San Sebastián,Balearic Islands,Cartagena (Spain)`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1840`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Exp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`531112.083018568`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`9`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cadix,Málaga,Cartagena (Spain),San Sebastián,Bilbao,Santander,Gijón,A Coruna,Balearic Islands`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Spain`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`1840`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Imp`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`France`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`559818.695081707`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`9`}</td>
            <td parentName="tr" {...{
              "align": "center"
            }}>{`Cadix,Málaga,Cartagena (Spain),San Sebastián,Bilbao,Santander,Gijón,A Coruna,Balearic Islands`}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="citation" style={{
      marginTop: "1rem"
    }}><b>Dedinger, P. G., Beatrice</b> (2018). RICardo World Trade Web, 1834-1938 Paper presented at the research seminar of Department of Economic History, Lund University, Lund, SE <a href="https://medialab.github.io/ricardo/Lund_seminar_20181010">https://medialab.github.io/ricardo/Lund_seminar_20181010</a> (accessed 25 July 2022).</div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide24.isMDXComponent = true;

function MDXContentWrapperSlide25(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <FlexBox alignItems="center" justifyContent="center" height="100%" flexDirection="column" mdxType="FlexBox">
  <h1>Thank you</h1>
  <Link href="https://ricardo.medialab.sciences-po.fr" style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "1rem"
      }} mdxType="Link">
    <Image src={RICardoLogo} height="5rem" style={{
          marginRight: "2rem"
        }} mdxType="Image" />
    ricardo.medialab.sciences-po.fr
  </Link>
  <Link href="https://medialab.github.io/GeoPolHist" style={{
        display: "flex",
        alignItems: "center"
      }} mdxType="Link">
    <Image src={GPHLogo} height="5rem" style={{
          marginRight: "2rem"
        }} mdxType="Image" />
    medialab.github.io/GeoPolHist
  </Link>
    </FlexBox>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide25.isMDXComponent = true;

function MDXContentWrapperSlide26(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Link fontSize="3rem" style={{
      marginTop: "1rem",
      backgroundColor: "white"
    }} href="https://ouestware.gitlab.io/retina/beta/#/graph/?url=https%3A%2F%2Fmedialab.github.io%2Fricardo%2FWEHC_202207%2F1890.gexf&c=t&s=wot&sa[]=pg&sa[]=wot&ca[]=t&ca[]=g&ca[]=cn&ca[]=wot&fa=pr&nr=0.979" mdxType="Link">
  Trade in 1890
    </Link>
    <Link fontSize="3rem" style={{
      marginTop: "1rem",
      backgroundColor: "white"
    }} href="https://ouestware.gitlab.io/retina/beta/#/graph/?url=https%3A%2F%2Fmedialab.github.io%2Fricardo%2FWEHC_202207%2F1910.gexf&c=t&s=wot&sa[]=pg&sa[]=wot&ca[]=t&ca[]=g&ca[]=cn&ca[]=wot&fa=pr&nr=0.979" mdxType="Link">
  Trade in 1910
    </Link>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperSlide26.isMDXComponent = true;

function MDXContentWrapperNotes0(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes0.isMDXComponent = true;

function MDXContentWrapperNotes1(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes1.isMDXComponent = true;

function MDXContentWrapperNotes2(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes2.isMDXComponent = true;

function MDXContentWrapperNotes3(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes3.isMDXComponent = true;

function MDXContentWrapperNotes4(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes4.isMDXComponent = true;

function MDXContentWrapperNotes5(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes5.isMDXComponent = true;

function MDXContentWrapperNotes6(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes6.isMDXComponent = true;

function MDXContentWrapperNotes7(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes7.isMDXComponent = true;

function MDXContentWrapperNotes8(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes8.isMDXComponent = true;

function MDXContentWrapperNotes9(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes9.isMDXComponent = true;

function MDXContentWrapperNotes10(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes10.isMDXComponent = true;

function MDXContentWrapperNotes11(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes11.isMDXComponent = true;

function MDXContentWrapperNotes12(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes12.isMDXComponent = true;

function MDXContentWrapperNotes13(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes13.isMDXComponent = true;

function MDXContentWrapperNotes14(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes14.isMDXComponent = true;

function MDXContentWrapperNotes15(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes15.isMDXComponent = true;

function MDXContentWrapperNotes16(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes16.isMDXComponent = true;

function MDXContentWrapperNotes17(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes17.isMDXComponent = true;

function MDXContentWrapperNotes18(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes18.isMDXComponent = true;

function MDXContentWrapperNotes19(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes19.isMDXComponent = true;

function MDXContentWrapperNotes20(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes20.isMDXComponent = true;

function MDXContentWrapperNotes21(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes21.isMDXComponent = true;

function MDXContentWrapperNotes22(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes22.isMDXComponent = true;

function MDXContentWrapperNotes23(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes23.isMDXComponent = true;

function MDXContentWrapperNotes24(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes24.isMDXComponent = true;

function MDXContentWrapperNotes25(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes25.isMDXComponent = true;

function MDXContentWrapperNotes26(props) {
  /* @jsxRuntime classic */
/* @jsx mdx */





















const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  return (<MDXContent {...props} />);
};
MDXContentWrapperNotes26.isMDXComponent = true;


export const notes = [MDXContentWrapperNotes0,MDXContentWrapperNotes1,MDXContentWrapperNotes2,MDXContentWrapperNotes3,MDXContentWrapperNotes4,MDXContentWrapperNotes5,MDXContentWrapperNotes6,MDXContentWrapperNotes7,MDXContentWrapperNotes8,MDXContentWrapperNotes9,MDXContentWrapperNotes10,MDXContentWrapperNotes11,MDXContentWrapperNotes12,MDXContentWrapperNotes13,MDXContentWrapperNotes14,MDXContentWrapperNotes15,MDXContentWrapperNotes16,MDXContentWrapperNotes17,MDXContentWrapperNotes18,MDXContentWrapperNotes19,MDXContentWrapperNotes20,MDXContentWrapperNotes21,MDXContentWrapperNotes22,MDXContentWrapperNotes23,MDXContentWrapperNotes24,MDXContentWrapperNotes25,MDXContentWrapperNotes26];


export default [MDXContentWrapperSlide0,MDXContentWrapperSlide1,MDXContentWrapperSlide2,MDXContentWrapperSlide3,MDXContentWrapperSlide4,MDXContentWrapperSlide5,MDXContentWrapperSlide6,MDXContentWrapperSlide7,MDXContentWrapperSlide8,MDXContentWrapperSlide9,MDXContentWrapperSlide10,MDXContentWrapperSlide11,MDXContentWrapperSlide12,MDXContentWrapperSlide13,MDXContentWrapperSlide14,MDXContentWrapperSlide15,MDXContentWrapperSlide16,MDXContentWrapperSlide17,MDXContentWrapperSlide18,MDXContentWrapperSlide19,MDXContentWrapperSlide20,MDXContentWrapperSlide21,MDXContentWrapperSlide22,MDXContentWrapperSlide23,MDXContentWrapperSlide24,MDXContentWrapperSlide25,MDXContentWrapperSlide26]